module.exports = __webpack_public_path__ + "static/media/ico_contacto_new.207840e3.svg";